<template>
  <div>
    <div class="card">
      <div class="card-header" id="headingAlert">
        <h5>Current Visuals</h5>
        <router-link
          :to="{ name: 'AdvancedVisualAdd', params: { alert_id: alert_id } }"
          class="btn btn-hub-primary"
        >
          <i class="fa fa-edit" aria-hidden="true"></i> Add Visual
        </router-link>
      </div>
      <div class="card-body">
        <div class="row" v-for="advanced_visual in filtered_advanced_visuals" :key="advanced_visual.advanced_visual_id">
          <div class="col-12">
            <div class="dropdown text-right">
              <button
                class="btn btn-light dropdown-toggle"
                type="button"
                id="dropdownMenuButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i class="fa fa-cogs fa-fw" aria-hidden="true"></i>
              </button>
              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <router-link
                    :to="{ name: 'AdvancedVisualEdit', params: { alert_id: alert_id, advanced_visual_id: advanced_visual.advanced_visual_id } }"
                    class="dropdown-item"
                    >
                  <i class="fa fa-pencil-alt fa-fw" aria-hidden="true"></i
                  >&nbsp;Edit
                </router-link>
                <a
                  class="dropdown-item"
                  href="#"
                  onclick="return false"
                  @click="deleteAdvancedVisual(advanced_visual)"
                >
                  <i class="fa fa-trash fa-fw" aria-hidden="true"></i
                  >&nbsp;Delete
                </a>
              </div>
            </div>
            <AdvancedVisualPreview
              :advanced_visual="advanced_visual"
            ></AdvancedVisualPreview>
            <br><br>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AdvancedVisualPreview from '../Visual/AdvancedVisualPreview'

export default {
  props: { alert_id: { type: [Number, String] } },
  components: { AdvancedVisualPreview },
  data: function () {
    return {
      modal_type: 'EditVisual',
      advanced_visual_id_to_edit: 0
    }
  },
  computed: {
    ...mapGetters({
      advanced_visuals: 'allAdvancedVisuals'
    }),
    filtered_advanced_visuals: function () {
      return this.advanced_visuals.filter((v) => v.alert_id === parseInt(this.alert_id))
    }
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', false)
    this.$store.dispatch('getAdvancedVisuals')
  },
  methods: {
    ...mapActions(['deleteAdvancedVisual'])
  }
}
</script>

<style scoped>
</style>
